import React from 'react'

const Edit = props => (
  <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
    <defs>
      <path
        d='M8.9524059 20.8334302L21.2074343 8.57840182c1.0567543-1.05675427 1.0567543-2.76986488 0-3.82661915l-1.959217-1.95921697c-1.0567542-1.05675427-2.7698648-1.05675427-3.8266191 0L3.16656977 15.0475941c-.13293927.1329393-.22101863.3040942-.25192638.4895407l-.9020336 5.4122015c-.1017526.6105156.4275383 1.1398065 1.03805383 1.0380539l5.41220156-.9020336c.18544653-.0309077.3566014-.1189871.48954067-.2519264zm-6.19832906-.6255609l1.03805386 1.0380539.9020336-5.4122016-.2519264.4895407L16.6972663 4.06823384c.3522222-.3522222.9230607-.3522222 1.2752829 0l1.959217 1.95921697c.3522222.35222225.3522222.9230607 0 1.2752829L7.67673774 19.5577621l.48954067-.2519264-5.41220153.9020336zm15.29604726-9.7478254c.352266.352266.9234021.352266 1.2756681 0 .3522661-.352266.3522661-.92340212 0-1.27566815l-4.510168-4.51016797c-.352266-.35226603-.9234021-.35226603-1.2756681 0-.352266.35226603-.352266.9234021 0 1.27566814l4.510168 4.51016798zM7.67673774 20.8334302c.35226603.3522661.92340212.3522661 1.27566815 0 .352266-.352266.352266-.9234021 0-1.2756681l-4.510168-4.510168c-.35226605-.352266-.9234021-.352266-1.27566816 0-.35226603.352266-.35226603.9234021 0 1.2756682l4.51016797 4.5101679z'
        id='edit-a'
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id='edit-b' fill='#fff'>
        <use xlinkHref='#edit-a' />
      </mask>
      <path
        d='M0 0h100v40H0z'
        mask='url(#edit-b)'
        fill='#526173'
        id='icon-outline'
      />
    </g>
  </svg>
)

export default Edit



// WEBPACK FOOTER //
// ./src/svg-icons/Edit.js